import {
  getCLS,
  getFID,
  getLCP,
  Metric as WebVitalMetric,
  ReportHandler,
} from 'web-vitals';

export type CoreWebVitalMetricName = WebVitalMetric['name'] &
  ('CLS' | 'FID' | 'LCP');

const sendReport: ReportHandler = (metric: WebVitalMetric) => {
  const eventData = {
    ...metric,
    deltaRounded: Math.round(
      metric.name === 'CLS' ? metric.delta * 1000 : metric.delta
    ),
  };

  if (IS_BROWSER && window.dataLayer) {
    window.dataLayer.push({
      event: 'webVitalReport',
      webVitalReport: eventData,
    });
  }
};

const addWebVitalReport = (metricName: CoreWebVitalMetricName) => {
  switch (metricName) {
    case 'CLS':
      getCLS(sendReport);
      break;
    case 'FID':
      getFID(sendReport);
      break;
    case 'LCP':
      getLCP(sendReport);
      break;
    default:
      (() => {})();
  }
};

export default addWebVitalReport;
